// Promoted from golive/components/DataTable/DataTableBodyCell.jsx (unchanged).
import PropTypes from "prop-types";

const ALIGN = {
  left: "text-left",
  right: "text-right",
  center: "text-center",
};

export default function DataTableBodyCell({ noBorder = false, align = "left", children }) {
  return (
    <td
      className={[
        "py-2 px-6 text-sm",
        ALIGN[align] ?? "text-left",
        noBorder ? "" : "border-b border-gray-200",
      ].join(" ")}
    >
      <div className="text-slate-600 align-middle">{children}</div>
    </td>
  );
}

DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};
